import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import getChartColorsArray from '../../../../../Components/Common/ChartsDynamicColor';
import data_mortality from './DataDummy/mortality.json'
import data_mortality_cage from './DataDummy/mortality_cage.json'

const Mortality = ({ title, dataColors }) => {

    const [seriesMonth, setSeriesMonth] = useState([]);
    const [seriesCage, setSeriesCage] = useState([]);
    const [monthsFound, setMonthsFound] = useState([]);
    const [cagesFound, setCagesFound] = useState([]);

    useEffect(() => {
        // Simula la lógica de transformación
        const series = [
            {
                name: "Unidades",
                type: "column",
                data: data_mortality.map((item) => item.totalFishCount), // Unidades en toneladas
            },
            {
                name: "Moratilidad",
                type: "column",
                data: data_mortality.map((item) => item.totalLossCount), // Unidades Proyectada en toneladas
            },
            {
                name: "Biomasa",
                type: "line",
                data: data_mortality.map((item) => Math.round(item.totalBiomass / 1000)), // Biomasa en toneladas
            },
        ];
        const series_cage = [
            {
                name: "Unidades",
                type: "column",
                data: data_mortality_cage.map((item) => item.totalFishCount), // Unidades en toneladas
            },
            {
                name: "Moratilidad",
                type: "column",
                data: data_mortality_cage.map((item) => item.totalLossCount), // Unidades Proyectada en toneladas
            },
            {
                name: "Biomasa",
                type: "line",
                data: data_mortality_cage.map((item) => Math.round(item.totalBiomass / 1000)), // Biomasa en toneladas
            },
        ];
        

        const months = data_mortality.map((item) => item.monthYear);
        const cages = data_mortality_cage.map((item) => item.unit);

        // setSeriesMonth(series);
        // setSeriesCage(series_cage);
        // setMonthsFound(months);
        // setCagesFound(cages);
    }, []);



    const chartMultiColors = getChartColorsArray(dataColors);

    // Estado para controlar la vista: Jaula o Mes
    const [selectedView, setSelectedView] = useState('cage');


    const options = {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            width: [1, 1, 1],
        },
        xaxis: {
            categories: selectedView === 'cage'
                ? cagesFound
                : monthsFound,
            labels: {
                style: {
                    fontSize: '8px', // Tamaño del texto del eje X ajustado a 8px
                },
                formatter: function (value) {
                    if (value == null) return ""; // Maneja valores undefined o null
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                },
            },
        },
        yaxis: [
            {
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: "#038edc",
                },
                labels: {
                    style: {
                        colors: "#038edc",
                        fontSize: '8px',
                    },
                    formatter: function (value) {
                        if (value == null) return ""; // Maneja valores undefined o null
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    },
                },
                title: {
                    text: "Unidades",
                    style: {
                        color: "#038edc",
                        fontWeight: 600,
                    },
                },
                tooltip: {
                    enabled: true,
                },
            },
            {
                opposite: true,
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: "#038edc",
                },
                labels: {
                    style: {
                        colors: "#038edc",
                        fontSize: '8px',
                    },
                    formatter: function (value) {
                        if (value == null) return ""; // Maneja valores undefined o null
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    },
                },
                title: {
                    text: "Mortalidad - kg",
                    style: {
                        color: "#038edc",
                        fontWeight: 600,
                    },
                },
            },
            {
                opposite: true,
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: "#51d28c",
                },
                labels: {
                    style: {
                        colors: "#51d28c",
                        fontSize: '8px',
                    },
                    formatter: function (value) {
                        if (value == null) return ""; // Maneja valores undefined o null
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    },
                },
                title: {
                    text: "Biomasa - ton",
                    style: {
                        color: "#51d28c",
                        fontWeight: 600,
                    },
                },
            },
        ],
        tooltip: {
            fixed: {
                enabled: true,
            },
        },
        legend: {
            horizontalAlign: "center",
            offsetX: 40,
        },
        colors: chartMultiColors,
    };
    
    

    const getSelectedSeries = () => {
        return selectedView === 'cage' ? seriesCage : seriesMonth;
    };

    return (
        <Card style={{ height: "100%" }}>
            <CardHeader className='p-2 align-items-center d-flex'>
                <h5 className="card-title mb-0 flex-grow-1">Moratlidad</h5>
                <div className='btn-box-dashboard'>
                    <Button
                        color="secondary"
                        size="sm"
                        className="btn-soft-secondary me-1"
                        onClick={() => setSelectedView('cage')}
                        active={selectedView === 'cage'}
                    >
                        Jaula
                    </Button>
                    <Button
                        color="primary"
                        size="sm"
                        className="btn-soft-primary me-1"
                        onClick={() => setSelectedView('month')}
                        active={selectedView === 'month'}
                    >
                        Mes
                    </Button>
                </div>
            </CardHeader>
            <CardBody className='p-2'>
                <div className="w-100">
                    <div dir="ltr">
                        <ReactApexChart
                            dir="ltr"
                            className="apex-charts"
                            options={{
                                ...options,
                                noData: {
                                    text: "No hay datos disponibles. Pronta conexión con el sistema de alimentación",
                                    align: "center",
                                    verticalAlign: "middle",
                                    style: {
                                        color: "#999",
                                        fontSize: "11px",
                                    },
                                },
                            }}
                            series={getSelectedSeries()}
                            type="line"
                            height={200}
                        />

                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default Mortality;
